'use strict';

module.exports = function getScript(src, callback) {
	var node = document.createElement('script'),
		script = document.getElementsByTagName('script')[0];
	node.src = src;
	node.type = 'text/javascript';
	node.onload = node.onerror = node.onreadystatechange = function () {
		/loaded|complete|undefined/.test(node.readyState) && function () {
			node.onload = node.onerror = node.onreadystatechange = null;
			node.parentNode.removeChild(node);
			node = undefined;
			callback && callback();
		}();
	};
	script.parentNode.insertBefore(node, script);
};